import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, SimpleChanges, OnChanges, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith, debounceTime, switchMap } from 'rxjs/operators';
import { GenericService } from '@huge-monorepo/hip/services';
import { Environment } from '@huge-monorepo/hip/services';

@Component({
  selector: 'tools-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() column: string = 'name';
  @Input() detailsColumn: string = null;
  @Input() path: string = '';
  @Input() initialData: any[];
  @Input() hasInitialData: boolean = false;
  @Input() placeholder: string = 'Enter your value here.';
  @Input() checked: string;
  @Input() ObjectListKey: string;
  @Input() disabled: Boolean = false;
  @Input() sort: boolean = false;
  @Input() sortColumn: string = 'Name';
  @Input() count: number = 50;
  @Input() clearAfterSelection: Boolean = false;
  @Input() methodPost: Boolean = false;
  @Input() postObject: any;
  @Input() formatFunction: Function;
  @Input() reformattingFunction: Function;
  @Input() isRequired: boolean = true;
  @Input() hasErrorMessage: boolean = false;
  @Input() errorMessage: string = 'This field is required.';
  @Input() data: any = null;
  @Input() detectUrlChanges: boolean = false;
  @Input() initialNull:boolean = true;

  @Output() selected: EventEmitter<any> = new EventEmitter<string>();

  myControl = new UntypedFormControl();
  filteredOptions: Observable<any[]>;
  options: any = [];
  firstTime: boolean = true;

  constructor(private genericService: GenericService, @Inject(Environment) private environment: any) { }

  ngOnChanges(changes: SimpleChanges) {
    // You can also use categoryId.previousValue and
    // categoryId.firstChange for comparing old and new values
    if (changes['disabled'] != null) {
      if (changes['disabled'].currentValue === true) {
        this.disable();
      } else {
        this.enable();
      }
    }
    if (this.detectUrlChanges) {
      if (changes['path'] != null) {
        this.myControl.setValue('');
      }
    }
  }

  ngOnInit() {
    if (this.disabled) {
      this.myControl.disable();
    }

    if (this.isRequired) {
      this.myControl.setValidators([Validators.required]);
    }
    if (this.data == null) {
      if (this.methodPost && this.checked != null) {
        this.myControl.setValue(this.checked);
      } else if (this.checked != null && this.checked.length > 0) {
        this.getData();
      }
    } else {
      this.myControl.setValue(this.data);
    }
  }

  getData() {
    let hasParams = this.path.indexOf('?');
    let url =
      this.environment.apiLink +
      this.path +
      (hasParams !== -1 ? '&' : '?') +
      'search=' +
      (this.checked ?? '') +
      '&count=' +
      (this.count ?? '0') +
      (this.sort ? '&orderBy=' + this.sortColumn : '');

    this.genericService.GET(url).subscribe((res) => {
      let results = [];
      if (res['body'] != null) {
        if (this.ObjectListKey != null) {
          results = res['body'][this.ObjectListKey] as [];
        } else {
          results = res['body'] as [];
        }
        if (results.length > 0) {
          this.selected.emit(results[0]);
          results[0]['Display'] = results[0][this.column];
          this.myControl.setValue(results[0]);
        }
      }
    });
  }


  ngAfterViewInit() {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      switchMap((value) => {
        if (typeof this.myControl.value != 'object' && this.initialNull) {
          this.selected.emit(null);
        }
        let tmp = this.doFilter(value);
        if (tmp == null) {
          return [];
        } else {
          return tmp;
        }
      }),
    );
  }

  nameDisplayFn(ob?: any): any {
    return ob != null ? ob['Name'] : ob;
  }

  displayFn(ob?: any): any {
    if (ob != null) {
      if (!ob['Display']) {
        return ob;
      } else {
        return ob['Display'];
      }
    }
  }

  doFilter(name: any) {
    if (this.firstTime && this.hasInitialData) {
      this.firstTime = false;
      if (this.initialData == null) {
        return of(null);
      }
      let data = this.initialData.map((elem) => {
        if (this.formatFunction != null) {
          elem['Display'] = this.formatFunction(elem);
        } else {
          elem['Display'] = elem[this.column];
        }
        return elem;
      });
      this.options = data;
      return of(data);
    }
    if (typeof name == 'string') {
      let hasParams = this.path.indexOf('?');
      let url =
        this.environment.apiLink + this.path + (hasParams !== -1 ? '&' : '?') + 'search=' + name + '&count=' + this.count + (this.sort ? '&orderBy=' + this.sortColumn : '');
      if (this.methodPost) {
        let obj = {
          AllGroups: false,
          GroupIds: [],
        };

        return this.genericService.POST(url, this.postObject != null ? this.postObject : obj).pipe(
          map((res) => {
            if (res != null) {
              let response = this.ObjectListKey != null ? res[this.ObjectListKey] : res;
              if (response != null) {
                response.forEach((element) => {
                  if (this.formatFunction != null) {
                    element['Display'] = this.formatFunction(element);
                  } else {
                    element['Display'] = element[this.column];
                  }
                });
              }
              this.options = response;
              return response;
            }
          }),
        );
      } else {
        return this.genericService.GET(url).pipe(
          map((res) => {
            let obj = res['body'];
            if (obj != null) {
              let response = this.ObjectListKey != null ? obj[this.ObjectListKey] : obj;
              if (response != null) {
                response.forEach((element) => {
                  if (this.formatFunction != null) {
                    element['Display'] = this.formatFunction(element);
                  } else {
                    element['Display'] = element[this.column];
                  }
                });
              }
              this.options = response;
              return response;
            }
          }),
        );
      }
    } else {
      return of(this.options);
    }
  }

  notifySelected(obj: any) {
    this.selected.emit(obj);
    if (this.clearAfterSelection) {
      setTimeout(() => {
        this.reset();
        this.unMarkAsTouched();
      });
    }
  }

  reset() {
    this.myControl.setValue(null);
  }

  markAsTouched() {
    if (this.isRequired) {
      this.myControl.setErrors({ invalid: true });
      this.myControl.markAsTouched();
    }
  }

  unMarkAsTouched() {
    this.myControl.setErrors(null);
  }

  disable() {
    this.myControl.disable();
  }

  enable() {
    this.myControl.enable();
  }
}
